module.exports = __webpack_public_path__ + "media/newstyle/images/services-footer-3-d579f63aa1653f5eb2b62b7a7579b6c8.png";